import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardAtividade, Container } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function AtividadesList({ defaultData, setter, setterSoma, clonaCronograma }) {
  const atividadePad = [];
  const [atividades, setAtividades] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        let aAtividade = [];
        let item = 1;

        if (clonaCronograma == "S") {
          for (const itemAtividade of defaultData) {
            let itensAtividade = [];
            let percentualEvol = 0;
  
            for (const itemItens of itemAtividade?.itensAtividade) {
              itensAtividade.push({ ...itemItens });

              percentualEvol += parseInt(itemItens?.percentualEvolucao) || 0;
            }
  
            aAtividade.push({
              ...itemAtividade,
              percentualEvolucao: parseInt(percentualEvol / (itemAtividade?.itensAtividade?.length)),
              itensAtividade
            });
  
            item++;
          }
        } else {
          for (const itemAtividade of defaultData) {
            let itensAtividade = [];
            let percentualEvol = 0;
            let itemAtiv = 0;
  
            if (itemAtividade?.itensAtividade && itemAtividade?.itensAtividade?.length > 0) {
              for (const itemItens of itemAtividade?.itensAtividade) {
                itensAtividade.push({
                  id: itemItens?.id,
                  indice: `${item}.${itemAtiv}`,
                  titulo: itemItens?.titulo,
                  responsabilidade: itemItens?.responsabilidade || "E",
                  dataPrevInicio: itemItens?.previsaoInicio,
                  dataPrevFinal: itemItens?.previsaoEntrega,
                  statusTarefa: itemItens?.statusTarefa || "N",
                  percentualEvolucao: parseInt(itemItens?.percentualEvolucao) || 0,
                });
  
                itemAtiv++;
                percentualEvol += parseInt(itemItens?.percentualEvolucao) || 0;
              }
            }
            
            aAtividade.push({
              item,
              id: itemAtividade?.id,
              indice: `${item}.0`,
              titulo: itemAtividade?.titulo,
              dataPrevInicio: itemAtividade?.previsaoInicio,
              dataPrevFinal: itemAtividade?.previsaoEntrega,
              percentualEvolucao: parseInt(percentualEvol / itemAtiv),
              itensAtividade
            });
  
            item++;
          }
        }
        
        setAtividades(aAtividade);
        setter(aAtividade);
      }
    }
  }, [defaultData, clonaCronograma]);
  
  useEffect(() => {
    setter(atividades);
  }, [atividades]);

  function handleAddAtividade() {
    setAtividades((prev) => [...prev, { item: (atividades?.length > 0 ? atividades[atividades?.length - 1]?.item + 1 : 1), id: 0, abertoAtividade: false, idDesc: "0 - Sem SD", titulo: "Atividade de Projeto", descricao: "", horaTotal: 0 }]);
  }

  function handleRemoveAtividade(data) {
    setAtividades((prev) => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex((e) => e?.item === data?.item);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
  }

  function handleRemoveAnalista(index, iAnal) {
    setAtividades((prev) => {
      const newPrev = [...prev];
      let itensAtividade = [];
      let count = 0;

      for (const itemAnal of newPrev[index].itensAtividade) {
        if (count != iAnal) {
          itensAtividade.push(itemAnal);
        }

        count++;
      }

      newPrev[index].itensAtividade = itensAtividade;

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Atividades *" className="titulo-label" row={true}>
        {/* {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddAtividade}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )} */}
      </Label>
      <CardAtividade>
        <div className="card-atv-header">
          <div className="titulos-tab">
            <div className="w1">
              <div className="top-header">
                -
              </div>
            </div>
            <div className="col w1">
              <p className="titulo">Índice</p>
            </div>
            <div className="col w5">
              <p className="titulo">Título <span></span></p>
            </div>
            <div className="col w3">
              <p className="titulo">Prev Inicio <span>*</span></p>
            </div>
            <div className="col w3">
              <p className="titulo">Prev Entrega <span>*</span></p>
            </div>
            <div className="col w2">
              <p className="titulo">% Evolução <span>*</span></p>
            </div>
            {/* <div className="hora-lib">
              <p className="titulo">Hora Lib <span></span></p>
            </div> */}
          </div>
        </div>
        {atividades?.map((itemData, index) => (
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <div className="w1">
                <div className="top-header">
                  <div onClick={(e) => { handleRemoveAtividade(itemData) }} className="icon-button material-icons">delete</div>
                </div>
              </div>
              <div className="col w1">
                <Input
                  placeholder="1"
                  name="indiceAt"
                  required="true"
                  value={itemData?.indice}
                  disabled={true}
                />
              </div>
              <div className="col w5">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  value={itemData?.titulo}
                  disabled={true}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].titulo = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="col w3">
                <Input
                  type="date"
                  name="dataPrevInicioTarefaAt"
                  value={itemData?.dataPrevInicio}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataPrevInicio = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="col w3">
                <Input
                  type="date"
                  name="dataPrevFinalTarefaAt"
                  value={itemData?.dataPrevFinal}
                  onChange={(e) => {
                    const v = e.currentTarget.value ||  "";
                    
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataPrevFinal = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="col w2">
                <Input
                  type="number"
                  name="percentualEvolucaoTarefaAt"
                  value={itemData?.percentualEvolucao}
                  disabled={true}
                />
              </div>
            </div>
            {itemData?.itensAtividade?.length > 0 && (
              <div className="sub-atividade">
                {/* <div className="card-sub-atv-header">
                  <div className="titulos-tab">
                    <div className="col w1">
                      <p className="titulo"></p>
                    </div>
                    <div className="col w1">
                      <p className="titulo">Índice</p>
                    </div>
                    <div className="col w5">
                      <p className="titulo">Título Tarefa <span>*</span></p>
                    </div>
                    <div className="col w2">
                      <p className="titulo">Responsavel <span>*</span></p>
                    </div>
                    <div className="col w2">
                      <p className="titulo">Status Tarefa <span>*</span></p>
                    </div>
                    <div className="col w2">
                      <p className="titulo">Prev Inicio <span>*</span></p>
                    </div>
                    <div className="col w2">
                      <p className="titulo">Prev Entrega <span>*</span></p>
                    </div>
                    <div className="col w1">
                      <p className="titulo">% Evol. <span>*</span></p>
                    </div>
                  </div>
                </div> */}
                {itemData?.itensAtividade?.map((itemAtividade, indexAtividade) => (
                  <div className="row no-margin row-top">
                    <div className="col w1">
                      <div className="top-header">
                        {itemAtividade?.horaUsadaReal == 0 || !itemAtividade?.horaUsadaReal ? (<div onClick={(e) => { handleRemoveAnalista(index, indexAtividade) }} className="icon-button material-icons">delete</div>) : <div />}
                      </div>
                    </div>
                    <div className="col w1">
                      <Input
                        placeholder="1"
                        name="indiceAt"
                        required="true"
                        value={itemAtividade?.indice}
                        disabled={true}
                      />
                    </div>
                    <div className="col w5">
                      <Input
                        placeholder="Titulo da Tarefa"
                        name="tituloTarefaAt"
                        required="true"
                        value={itemAtividade?.titulo}
                        disabled={true}
                      />
                    </div>
                    <div className="col w2">
                      <Select
                        isString
                        list={{ list: [{ id: "E", titulo: "Erpworks" }, { id: "C", titulo: "Cliente" }], value: "id", label: "titulo" }}
                        name={"responsabilidade" + indexAtividade}
                        firstOption
                        required="true"
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            const newPrev = [...prev];
                            let itensAtividade = [];
                            let count = 0;

                            for (const itemAtividade of newPrev[index].itensAtividade) {
                              if (count == indexAtividade) {
                                itensAtividade.push({ ...itemAtividade, responsabilidade: v });
                              } else {
                                itensAtividade.push(itemAtividade);
                              }

                              count++;
                            }
                            newPrev[index].itensAtividade = itensAtividade;

                            return newPrev;
                          });
                        }}
                        value={itemAtividade?.responsabilidade}
                      />
                    </div>
                    <div className="col w2">
                      <Select
                        isString
                        list={{ list: [{ id: "N", titulo: "Não Iniciado" }, { id: "E", titulo: "Em Execução" }, { id: "C", titulo: "Concluído" }], value: "id", label: "titulo" }}
                        name={"statusTarefa" + indexAtividade}
                        required="true"
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            const newPrev = [...prev];
                            let itensAtividade = [];
                            let count = 0;

                            for (const itemAtividade of newPrev[index].itensAtividade) {
                              if (count == indexAtividade) {
                                itensAtividade.push({ ...itemAtividade, statusTarefa: v });
                              } else {
                                itensAtividade.push(itemAtividade);
                              }

                              count++;
                            }
                            newPrev[index].itensAtividade = itensAtividade;

                            return newPrev;
                          });
                        }}
                        value={itemAtividade?.statusTarefa}
                      />
                    </div>
                    <div className="col w2">
                      <Input
                        type="date"
                        name="dataPrevInicioTarefaAt"
                        value={itemAtividade?.dataPrevInicio}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.itensAtividade) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, dataPrevInicio: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].itensAtividade = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="col w2">
                      <Input
                        type="date"
                        name="dataPrevFinalTarefaAt"
                        value={itemAtividade?.dataPrevFinal}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index]?.itensAtividade) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, dataPrevFinal: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].itensAtividade = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="col w1">
                      <Input
                        type="number"
                        name="percentualEvolucaoTarefaAt"
                        value={itemAtividade?.percentualEvolucao}
                        onChange={(e) => {
                          const v = parseInt(e.currentTarget.value) || 0;
                          setAtividades((prev) => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            let percentualEvol = 0;
                            for (const itemAnal of newPrev[index]?.itensAtividade) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, percentualEvolucao: v });
                                percentualEvol += v;
                              } else {
                                listaItens.push(itemAnal);
                                percentualEvol += itemAnal?.percentualEvolucao;
                              }

                              count++;
                            }

                            newPrev[index].itensAtividade = listaItens;
                            newPrev[index].percentualEvolucao = percentualEvol / count;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </CardAtividade>
      {/* ))} */}
    </Container>
  );
}

export default AtividadesList;
